import moment from "moment";
import { transformNccnResponse } from "../../../api/postCall/nccnGuidelines";
import {
  TableCellType,
  TableHeader,
} from "../../../components/custom-table/table";
import { EventForAuditTrail } from "../../../data-model/viewAllEvents";
import {
  EventBadgeBgColorForUI,
  EventBadgeTextColorForUI,
  EventType,
  EventTypeTextForUI,
} from "../../../enums/eventType";
import { AuditTrialTableColumnKeys } from "../../../enums/tableColumnKeys";
import { capitalizeWordsSeperatedByUnderScore } from "../../../utils/stringModifications";

export const ViewAllAuditTrailColumnHeaders: TableHeader[] = [
  {
    label: "Timestamp",
    key: AuditTrialTableColumnKeys.TIMESTAMP,
    order: 1,
    width: 25,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Actions",
    key: AuditTrialTableColumnKeys.ACTIONS,
    order: 1,
    width: 50,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Event Type",
    key: AuditTrialTableColumnKeys.EVENT_TYPE,
    order: 3,
    width: 15,
    type: TableCellType.BADGE,
  },
  {
    label: "",
    key: AuditTrialTableColumnKeys.VIEW_SCREENSHOT,
    order: 4,
    width: 10,
    type: TableCellType.VIEW_ICON_FOR_SCREENSHOT_OR_API_RESPONSE,
  },
];

export const generateViewAllAuditTrailTableData = (
  data: EventForAuditTrail[],
) => {
  return data.map((item) => {
    const screenshotPath = item?.metadata?.screenshot_path;

    const showEyeIcon =
      item?.event_type === EventType.API_CALL_DETAILS || screenshotPath;

    return {
      [AuditTrialTableColumnKeys.TIMESTAMP]: moment(item?.created_at).format(
        "MM/DD/YYYY HH:mm:ss",
      ),
      [AuditTrialTableColumnKeys.ACTIONS]: capitalizeWordsSeperatedByUnderScore(
        checkForClickJS(item?.event_name ?? ""),
      ),
      [AuditTrialTableColumnKeys.EVENT_TYPE]: getEventTypeTagAndColor(
        item?.event_name ?? "",
        item?.event_type ?? "",
      ),
      [AuditTrialTableColumnKeys.VIEW_SCREENSHOT]: {
        shouldHideIcon: !showEyeIcon,
        shouldShowApiResponseModal:
          item?.event_type === EventType.API_CALL_DETAILS,
        shouldShowScreenshotModal:
          item?.event_type === EventType.RPA_ACTIONS_DETAILS,
        screenshotData: {
          filePath: screenshotPath,
        },
        apiResponseData: {
          apiName: capitalizeWordsSeperatedByUnderScore(item?.event_name ?? ""),
          totalEntries: 1,
          selectedApiRequest: 0,
          requestData: item?.metadata?.request_data ?? {},
          responseData: item?.metadata?.response_data ?? {},
          statusCode: item?.metadata?.status_code ?? 500,
        },
        shouldShowPdfIcon:
          item?.metadata?.doc_path && item?.metadata?.doc_type !== ""
            ? true
            : false,
        pdfData: {
          filePath: item?.metadata?.doc_path ?? "",
          title: capitalizeWordsSeperatedByUnderScore(
            checkForClickJS(item?.event_name ?? ""),
          ),
        },
        shouldOpenMultipleDocViewerModal:
          item?.event_name?.toLowerCase() === "fetch_guidelines",
        multipleDocPaths:
          item?.event_name?.toLowerCase() === "fetch_guidelines" &&
          transformNccnResponse(item?.metadata?.response_data ?? {}),
      },
      [AuditTrialTableColumnKeys.ROW_DATA]: {
        ...item,
      },
    };
  });
};

const getEventTypeTagAndColor = (event_name: string, eventType: string) => {
  if (
    event_name.toLowerCase().includes("flatiron") &&
    eventType.toLowerCase().includes("api")
  ) {
    return {
      text: EventTypeTextForUI[EventType.FHIR_API_CALL],
      bgColor: EventBadgeBgColorForUI[EventType.FHIR_API_CALL],
      color: EventBadgeTextColorForUI[EventType.FHIR_API_CALL],
    };
  }

  return {
    text: EventTypeTextForUI[eventType],
    bgColor: EventBadgeBgColorForUI[eventType],
    color: EventBadgeTextColorForUI[eventType],
  };
};
export const checkForClickJS = (event_name: string) => {
  if (event_name.includes("click_javascript")) {
    event_name = event_name.replace("click_javascript", "click_web_element");
  }
  return event_name;
};
